import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Card, FormField, Input, Skeleton } from '../../components/ui/index.js';
import { api } from '../../lib/api.js';

interface TenantDto {
  id: string;
  name: string;
  slug: string;
  defaultLocale: 'en' | 'ar';
  baseCurrencyCode: string;
}

export function TenantPage(): JSX.Element {
  const { t } = useTranslation('settings');
  const { t: tc } = useTranslation();
  const [tenant, setTenant] = useState<TenantDto | null>(null);
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    void api()
      .get<TenantDto>('/tenants/current')
      .then((r) => {
        setTenant(r.data);
        setName(r.data.name);
      });
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    try {
      const r = await api().patch<TenantDto>('/tenants/current', { name });
      setTenant(r.data);
    } finally {
      setSaving(false);
    }
  };

  if (!tenant) {
    return (
      <Card>
        <Skeleton className="h-6 w-32" />
        <Skeleton className="mt-4 h-10 w-full" />
      </Card>
    );
  }

  return (
    <Card>
      <h2 className="mb-4 text-lg font-semibold">{t('tenant.title')}</h2>
      <form className="flex flex-col gap-4" onSubmit={onSubmit}>
        <FormField id="tname" label={t('tenant.name')}>
          <Input id="tname" value={name} onChange={(e) => setName(e.target.value)} />
        </FormField>
        <FormField id="tslug" label="Slug">
          <Input id="tslug" value={tenant.slug} disabled />
        </FormField>
        <FormField id="tcur" label={t('tenant.baseCurrency')}>
          <Input id="tcur" value={tenant.baseCurrencyCode} disabled />
        </FormField>
        <Button type="submit" loading={saving} className="self-start">
          {tc('actions.save')}
        </Button>
      </form>
    </Card>
  );
}
